import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OperationTheaterComponent} from './operation-theater.component';
import {routing} from './operation-theater.routing';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ConfirmDialogModule, MultiSelectModule, PanelModule} from 'primeng/primeng';
// for loading theme
import {LayoutModule} from '../layout/layout.module';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {MstProcedureService} from '../configuration/mst-procedure/mst-procedure.service';
import {OtdetailsListComponent} from './otdetails-list/otdetails-list.component';

// import { OtDetailsComponent } from './ot-details/ot-details.component';
@NgModule({
    imports: [
        CommonModule,
        routing,
        LayoutModule,
        FormsModule,
        HttpModule,
        BrowserAnimationsModule,
        MultiSelectModule,
        PanelModule,
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        SharedTranslationModule, ConfirmDialogModule
    ],
    declarations: [OperationTheaterComponent],
    providers: [MstProcedureService]
})
export class OperationTheaterModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/operation-theater/operation-theater.module.ts